
export default {
    'addressMain': 'OATXL',//通讯录
    'applicationAll': 'OAYYZX',//应用中心公告
    'main': 'OASY',//首页
    'CreateMember': 'TJCY',//添加成员
    'manageRole': 'QXGL',//权限管理
    'manageApplication': 'YYGL',//应用管理
    'manageVersion': 'BBGL',//版本管理
    'applicationRecord': 'FBGG',//发布公告
    "applicationManagement": 'FLGL',//分类管理
    'error':'ERROR',
    'login':'LOGIN',
    'memberDetail':'MEMBERDETAIL',
    "noticeDetail":'NOTICEDETAIL',
    "applicationDetailTwo":'APPDETAILTWO',
    "applicationDetail":'APPDETAIL',
    "applicationFn":'GGGL',
    'manageApplication':'YYGL',
    'manageVersion':'BBGL',
    "test":'TEST',
    "testEditor":'TEST',
    'applicationApproval':'应用中心默认永久权限',
    'applicationWorkbench':'应用中心默认永久权限',
    'applicationFormManage':'SPGL',
    'applicationRecList':'SPGL',
    'expenseReimburs':'SPGL',
    'costBasis':'SPGL',
    'designForm':'SPGL',
    'designProcess':'SPGL',
    'applicationFormTemplate':'SPGL',
    'applyForm':'应用中心默认永久权限',
    'newApplyForm':'应用中心默认永久权限',
    'copyMeForm':'应用中心默认永久权限',
    'copyMeFormNew':'应用中心默认永久权限',
    'library':'应用中心默认永久权限',
    'roleManage':'应用中心默认永久权限',
    'workReport':'应用中心默认永久权限',
    'writeReport':'应用中心默认永久权限',
    'reportSuccess':'应用中心默认永久权限',
    'lookReport':'应用中心默认永久权限',
    'submitReport':'应用中心默认永久权限',
    'reportDetail':'应用中心默认永久权限',
    "applicationProcessManage":'SPGL',
    "attendanceGroup":'KQDK',
    "attendGroupAdd":'KQZSZ',
    "monthlyStatist":'YDTJ',
    "dailyStatist":'MRTJ',
    "punchTime":'DKSJ',
    "originalRecord":'YSJL',
    "viewDeptStaff":"CKLZRY"
}



// WEBPACK FOOTER //
// ./src/router/routerAuthor.js